import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class TrainingCertificationStaffPaymentEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.training_certification_staff_payment_data.id,
      name: this.props.training_certification_staff_payment_data.staff.name,
      flight_in: this.props.training_certification_staff_payment_data.flight_in_str,
      flight_in: this.props.training_certification_staff_payment_data.flight_in_str,
      checkin: this.props.training_certification_staff_payment_data.checkin_str,
      date_start: this.props.training_certification_staff_payment_data.date_start_str,
      date_finish: this.props.training_certification_staff_payment_data.date_finish_str,
      checkout: this.props.training_certification_staff_payment_data.checkout_str,
      flight_out: this.props.training_certification_staff_payment_data.flight_out_str,
      daily_paid: this.props.training_certification_staff_payment_data.daily_paid,
      daily_value: this.props.training_certification_staff_payment_data.daily_value_str,
      daily_total: this.props.training_certification_staff_payment_data.daily_total_str,
      attendance: this.props.training_certification_staff_payment_data.attendance,
    };

    //bind específico
    this.edit = this.edit.bind(this);
  }

  // Handlers
  handleChangeDailyPaid (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
    var total = (parseInt(event.target.value) * this.props.training_certification_staff_payment_data.daily_value);
    if (isNaN(total) || total === '') {
      total = 0;
    }
    this.setState({daily_total: total.toFixed(2).replace(".", ",")});
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(newProps.updated === 1){
      this.setState({
        id: newProps.training_certification_staff_payment_data.id,
        name: newProps.training_certification_staff_payment_data.staff.name,
        flight_in: newProps.training_certification_staff_payment_data.flight_in_str,
        flight_in: newProps.training_certification_staff_payment_data.flight_in_str,
        checkin: newProps.training_certification_staff_payment_data.checkin_str,
        date_start: newProps.training_certification_staff_payment_data.date_start_str,
        date_finish: newProps.training_certification_staff_payment_data.date_finish_str,
        checkout: newProps.training_certification_staff_payment_data.checkout_str,
        flight_out: newProps.training_certification_staff_payment_data.flight_out_str,
        daily_paid: newProps.training_certification_staff_payment_data.daily_paid,
        daily_value: newProps.training_certification_staff_payment_data.daily_value_str,
        daily_total: newProps.training_certification_staff_payment_data.daily_total_str,
        attendance: newProps.training_certification_staff_payment_data.attendance,
      });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      flight_in: this.state.flight_in,
      flight_in: this.state.flight_in,
      checkin: this.state.checkin,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      checkout: this.state.checkout,
      flight_out: this.state.flight_out,
      daily_paid: this.state.daily_paid,
      daily_value: this.state.daily_value,
      daily_total: this.state.daily_total,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/aluno/diaria/simples', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
    <tr>
      <td>
        <RequestApi ref={'request_api'} />
        {self.state.name}
      </td>
      <td><InputMask value={this.state.flight_in}  maskChar={null} name="flight_in " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'flight_in')} placeholder="" /></td>
      <td><InputMask value={this.state.checkin}  maskChar={null} name="checkin " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'checkin')} placeholder="" /></td>
      <td><InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" /></td>
      <td><InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" /></td>
      <td><InputMask value={this.state.checkout}  maskChar={null} name="checkout " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'checkout')} placeholder="" /></td>
      <td><InputMask value={this.state.flight_out}  maskChar={null} name="flight_out " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'flight_out')} placeholder="" /></td>
      <td><input type="number" value={self.state.daily_paid} onChange={this.handleChangeDailyPaid.bind(this, 'daily_paid')} className="form-control" /></td>
      <td>{self.state.daily_value}</td>
      <td>{self.state.daily_total}</td>
      <td>{this.state.attendance === 1 ? <button className="btn btn-primary" onClick={this.edit}><i className="fa fa-fw fa-save"></i></button> : ""}</td>
    </tr>
    );
  }
}

export default TrainingCertificationStaffPaymentEdit;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingCertificationStaffPaymentEdit.js